import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withKeys as _withKeys, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b2ed7e3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "orangehrm-background-container finance-page" }
const _hoisted_2 = { class: "finance-heading" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "Company Expenses"),
  /*#__PURE__*/_createElementVNode("p", null, "Record, review, and approve company costs.")
], -1))
const _hoisted_4 = {
  class: "finance-tabs",
  role: "tablist"
}
const _hoisted_5 = {
  key: 0,
  class: "panel"
}
const _hoisted_6 = { class: "filters" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "All departments", -1))
const _hoisted_8 = ["value"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "All categories", -1))
const _hoisted_10 = ["value"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "All vendors", -1))
const _hoisted_12 = ["value"]
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<option value=\"\" data-v-7b2ed7e3>All statuses</option><option value=\"draft\" data-v-7b2ed7e3>Draft</option><option value=\"pending_approval\" data-v-7b2ed7e3>Pending Approval</option><option value=\"approved\" data-v-7b2ed7e3>Approved</option><option value=\"paid\" data-v-7b2ed7e3>Paid</option><option value=\"rejected\" data-v-7b2ed7e3>Rejected</option>", 6)
const _hoisted_19 = [
  _hoisted_13
]
const _hoisted_20 = { class: "search-filter" }
const _hoisted_21 = { class: "list-actions" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = {
  key: 0,
  class: "expense-form"
}
const _hoisted_24 = { class: "form-heading" }
const _hoisted_25 = { class: "form-grid" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: 0,
  disabled: ""
}, "Select category", -1))
const _hoisted_27 = ["value"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 0 }, "None", -1))
const _hoisted_29 = ["value"]
const _hoisted_30 = ["value"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "PKR" }, "PKR", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "USD" }, "USD", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "EUR" }, "EUR", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "GBP" }, "GBP", -1))
const _hoisted_35 = [
  _hoisted_31,
  _hoisted_32,
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = /*#__PURE__*/_createStaticVNode("<option value=\"\" data-v-7b2ed7e3>Select method</option><option value=\"cash\" data-v-7b2ed7e3>Cash</option><option value=\"bank_transfer\" data-v-7b2ed7e3>Bank transfer</option><option value=\"card\" data-v-7b2ed7e3>Card</option><option value=\"cheque\" data-v-7b2ed7e3>Cheque</option>", 5)
const _hoisted_41 = [
  _hoisted_36
]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 0 }, "None", -1))
const _hoisted_43 = ["value"]
const _hoisted_44 = { class: "checkbox-label" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "monthly" }, "Monthly", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "quarterly" }, "Quarterly", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "yearly" }, "Yearly", -1))
const _hoisted_49 = [
  _hoisted_46,
  _hoisted_47,
  _hoisted_48
]
const _hoisted_50 = { class: "full-width" }
const _hoisted_51 = { class: "full-width" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { key: 1 }
const _hoisted_54 = { class: "form-actions" }
const _hoisted_55 = ["disabled"]
const _hoisted_56 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_57 = {
  key: 2,
  class: "empty-state"
}
const _hoisted_58 = {
  key: 3,
  class: "table-wrap"
}
const _hoisted_59 = ["checked"]
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Date", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Reference", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Category", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Vendor", -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Amount", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Status", -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Actions", -1))
const _hoisted_67 = ["value"]
const _hoisted_68 = { class: "actions" }
const _hoisted_69 = ["href"]
const _hoisted_70 = ["onClick"]
const _hoisted_71 = ["onClick"]
const _hoisted_72 = ["onClick"]
const _hoisted_73 = ["onClick"]
const _hoisted_74 = ["onClick"]
const _hoisted_75 = ["onClick"]
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "5" }, "Total on this page", -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, null, -1))
const _hoisted_78 = { class: "pagination" }
const _hoisted_79 = ["disabled"]
const _hoisted_80 = ["disabled"]
const _hoisted_81 = {
  key: 1,
  class: "masters-grid"
}
const _hoisted_82 = { class: "panel" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Categories", -1))
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 0 }, "Top-level category", -1))
const _hoisted_85 = ["value"]
const _hoisted_86 = ["disabled"]
const _hoisted_87 = { class: "master-list" }
const _hoisted_88 = ["onClick"]
const _hoisted_89 = {
  key: 1,
  class: "muted"
}
const _hoisted_90 = { class: "panel" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Vendors", -1))
const _hoisted_92 = ["disabled"]
const _hoisted_93 = { class: "master-list" }
const _hoisted_94 = { key: 0 }
const _hoisted_95 = ["onClick"]
const _hoisted_96 = {
  key: 1,
  class: "muted"
}
const _hoisted_97 = {
  key: 2,
  class: "error-message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("button", {
        class: "primary",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.startNewExpense && _ctx.startNewExpense(...args)))
      }, "Add Expense")
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        class: _normalizeClass({active: _ctx.tab === 'expenses'}),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tab = 'expenses'))
      }, " Expense List ", 2),
      _createElementVNode("button", {
        class: _normalizeClass({active: _ctx.tab === 'masters'}),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.tab = 'masters'))
      }, " Categories & Vendors ", 2)
    ]),
    (_ctx.tab === 'expenses')
      ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("label", null, [
              _createTextVNode("From"),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.dateFrom) = $event)),
                type: "date"
              }, null, 512), [
                [_vModelText, _ctx.filters.dateFrom]
              ])
            ]),
            _createElementVNode("label", null, [
              _createTextVNode("To"),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.dateTo) = $event)),
                type: "date"
              }, null, 512), [
                [_vModelText, _ctx.filters.dateTo]
              ])
            ]),
            _createElementVNode("label", null, [
              _createTextVNode("Department"),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.departmentId) = $event))
              }, [
                _hoisted_7,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.departments, (item) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: item.id,
                    value: String(item.id)
                  }, _toDisplayString(item.name), 9, _hoisted_8))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.filters.departmentId]
              ])
            ]),
            _createElementVNode("label", null, [
              _createTextVNode("Category"),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters.categoryId) = $event))
              }, [
                _hoisted_9,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeCategories, (item) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: item.id,
                    value: String(item.id)
                  }, _toDisplayString(item.name), 9, _hoisted_10))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.filters.categoryId]
              ])
            ]),
            _createElementVNode("label", null, [
              _createTextVNode("Vendor"),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters.vendorId) = $event))
              }, [
                _hoisted_11,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeVendors, (item) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: item.id,
                    value: String(item.id)
                  }, _toDisplayString(item.name), 9, _hoisted_12))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.filters.vendorId]
              ])
            ]),
            _createElementVNode("label", null, [
              _createTextVNode("Status"),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filters.status) = $event))
              }, _hoisted_19, 512), [
                [_vModelSelect, _ctx.filters.status]
              ])
            ]),
            _createElementVNode("label", _hoisted_20, [
              _createTextVNode("Search"),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filters.search) = $event)),
                placeholder: "Reference, vendor or description",
                onKeyup: _cache[10] || (_cache[10] = _withKeys(
//@ts-ignore
(...args) => (_ctx.searchExpenses && _ctx.searchExpenses(...args)), ["enter"]))
              }, null, 544), [
                [_vModelText, _ctx.filters.search]
              ])
            ]),
            _createElementVNode("button", {
              class: "secondary",
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.searchExpenses && _ctx.searchExpenses(...args)))
            }, "Search"),
            _createElementVNode("button", {
              class: "ghost",
              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args)))
            }, "Reset")
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("span", null, _toDisplayString(_ctx.totalRecords) + " records", 1),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "secondary",
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.exportCsv && _ctx.exportCsv(...args)))
              }, "Export CSV"),
              _createElementVNode("button", {
                class: "danger-button",
                disabled: _ctx.selectedIds.length === 0,
                onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.bulkDelete && _ctx.bulkDelete(...args)))
              }, " Delete selected (" + _toDisplayString(_ctx.selectedIds.length) + ") ", 9, _hoisted_22)
            ])
          ]),
          (_ctx.showForm)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("h2", null, _toDisplayString(_ctx.form.id ? 'Edit Expense' : 'Add Expense'), 1),
                  _createElementVNode("button", {
                    class: "ghost",
                    onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.closeForm && _ctx.closeForm(...args)))
                  }, "Close")
                ]),
                _createElementVNode("form", {
                  onSubmit: _cache[30] || (_cache[30] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveExpense && _ctx.saveExpense(...args)), ["prevent"]))
                }, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("label", null, [
                      _createTextVNode("Date"),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.date) = $event)),
                        type: "date",
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.form.date]
                      ])
                    ]),
                    _createElementVNode("label", null, [
                      _createTextVNode("Category"),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.categoryId) = $event)),
                        required: ""
                      }, [
                        _hoisted_26,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeCategories, (item) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: item.id,
                            value: Number(item.id)
                          }, _toDisplayString(item.name), 9, _hoisted_27))
                        }), 128))
                      ], 512), [
                        [
                          _vModelSelect,
                          _ctx.form.categoryId,
                          void 0,
                          { number: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("label", null, [
                      _createTextVNode("Vendor"),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.vendorId) = $event))
                      }, [
                        _hoisted_28,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeVendors, (item) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: item.id,
                            value: Number(item.id)
                          }, _toDisplayString(item.name), 9, _hoisted_29))
                        }), 128))
                      ], 512), [
                        [
                          _vModelSelect,
                          _ctx.form.vendorId,
                          void 0,
                          { number: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("label", null, [
                      _createTextVNode("Amount"),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.amount) = $event)),
                        type: "number",
                        min: "0.01",
                        step: "0.01",
                        required: ""
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.form.amount,
                          void 0,
                          { number: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("label", null, [
                      _createTextVNode("Tax %"),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.taxPercent) = $event)),
                        type: "number",
                        min: "0",
                        max: "100",
                        step: "0.001"
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.form.taxPercent,
                          void 0,
                          { number: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("label", null, [
                      _createTextVNode("Total"),
                      _createElementVNode("input", {
                        value: _ctx.totalAmount,
                        type: "text",
                        readonly: ""
                      }, null, 8, _hoisted_30)
                    ]),
                    _createElementVNode("label", null, [
                      _createTextVNode("Currency"),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.currency) = $event)),
                        required: ""
                      }, _hoisted_35, 512), [
                        [_vModelSelect, _ctx.form.currency]
                      ])
                    ]),
                    _createElementVNode("label", null, [
                      _createTextVNode("Payment method"),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.paymentMethod) = $event)),
                        required: ""
                      }, _hoisted_41, 512), [
                        [_vModelSelect, _ctx.form.paymentMethod]
                      ])
                    ]),
                    _createElementVNode("label", null, [
                      _createTextVNode("Cost center"),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.form.costCenter) = $event))
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.form.costCenter,
                          void 0,
                          { trim: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("label", null, [
                      _createTextVNode("Department"),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.form.departmentId) = $event))
                      }, [
                        _hoisted_42,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.departments, (item) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: item.id,
                            value: Number(item.id)
                          }, _toDisplayString(item.name), 9, _hoisted_43))
                        }), 128))
                      ], 512), [
                        [
                          _vModelSelect,
                          _ctx.form.departmentId,
                          void 0,
                          { number: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("label", _hoisted_44, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.form.isRecurring) = $event)),
                        type: "checkbox"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.form.isRecurring]
                      ]),
                      _createTextVNode("Recurring")
                    ]),
                    (_ctx.form.isRecurring)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_45, [
                          _createTextVNode("Frequency"),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.form.recurrence) = $event))
                          }, _hoisted_49, 512), [
                            [_vModelSelect, _ctx.form.recurrence]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("label", _hoisted_50, [
                      _createTextVNode("Description"),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.form.description) = $event)),
                        rows: "3"
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.form.description,
                          void 0,
                          { trim: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("label", _hoisted_51, [
                      _createTextVNode("Receipt (PDF/JPEG/PNG, max 5 MB)"),
                      _createElementVNode("input", {
                        type: "file",
                        accept: "application/pdf,image/jpeg,image/png",
                        onChange: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.selectAttachment && _ctx.selectAttachment(...args)))
                      }, null, 32),
                      (_ctx.form.attachmentId)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_52, "An attachment is already saved; selecting a new file will replace it."))
                        : _createCommentVNode("", true),
                      (_ctx.form.attachmentFile)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_53, "Selected: " + _toDisplayString(_ctx.form.attachmentFile.name), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "ghost",
                      onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.closeForm && _ctx.closeForm(...args)))
                    }, " Cancel"),
                    _createElementVNode("button", {
                      class: "primary",
                      type: "submit",
                      disabled: _ctx.saving
                    }, _toDisplayString(_ctx.saving ? 'Saving…' : 'Save Draft'), 9, _hoisted_55)
                  ])
                ], 32)
              ]))
            : _createCommentVNode("", true),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_56, "Loading expenses…"))
            : (!_ctx.expenses.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_57, " No expenses match these filters. Add an expense to get started. "))
              : (_openBlock(), _createElementBlock("div", _hoisted_58, [
                  _createElementVNode("table", null, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            checked: _ctx.allSelected,
                            onChange: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.toggleAll && _ctx.toggleAll(...args)))
                          }, null, 40, _hoisted_59)
                        ]),
                        _hoisted_60,
                        _hoisted_61,
                        _hoisted_62,
                        _hoisted_63,
                        _hoisted_64,
                        _hoisted_65,
                        _hoisted_66
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expenses, (item) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: item.id
                        }, [
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.selectedIds) = $event)),
                              type: "checkbox",
                              value: Number(item.id)
                            }, null, 8, _hoisted_67), [
                              [_vModelCheckbox, _ctx.selectedIds]
                            ])
                          ]),
                          _createElementVNode("td", null, _toDisplayString(item.expense_date), 1),
                          _createElementVNode("td", null, _toDisplayString(item.ref_no), 1),
                          _createElementVNode("td", null, _toDisplayString(item.category_name), 1),
                          _createElementVNode("td", null, _toDisplayString(item.vendor_name || '—'), 1),
                          _createElementVNode("td", null, _toDisplayString(item.currency) + " " + _toDisplayString(Number(item.total).toFixed(2)), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["status", `status--${item.status}`])
                            }, _toDisplayString(_ctx.statusLabel(item.status)), 3)
                          ]),
                          _createElementVNode("td", _hoisted_68, [
                            (item.attachment_id)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "text-button",
                                  href: `${_ctx.baseUrl}/finance/expenses/${item.id}/attachment`,
                                  target: "_blank",
                                  rel: "noopener"
                                }, "Receipt", 8, _hoisted_69))
                              : _createCommentVNode("", true),
                            (['draft', 'rejected'].includes(item.status))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  class: "text-button",
                                  onClick: ($event: any) => (_ctx.editExpense(item))
                                }, " Edit ", 8, _hoisted_70))
                              : _createCommentVNode("", true),
                            (['draft', 'rejected'].includes(item.status))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 2,
                                  class: "text-button",
                                  onClick: ($event: any) => (_ctx.transition(item, 'pending_approval'))
                                }, " Submit ", 8, _hoisted_71))
                              : _createCommentVNode("", true),
                            (item.status === 'pending_approval')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 3,
                                  class: "text-button",
                                  onClick: ($event: any) => (_ctx.transition(item, 'approved'))
                                }, " Approve ", 8, _hoisted_72))
                              : _createCommentVNode("", true),
                            (item.status === 'pending_approval')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 4,
                                  class: "text-button danger",
                                  onClick: ($event: any) => (_ctx.transition(item, 'rejected'))
                                }, " Reject ", 8, _hoisted_73))
                              : _createCommentVNode("", true),
                            (item.status === 'approved')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 5,
                                  class: "text-button",
                                  onClick: ($event: any) => (_ctx.transition(item, 'paid'))
                                }, " Mark Paid ", 8, _hoisted_74))
                              : _createCommentVNode("", true),
                            (['draft', 'rejected'].includes(item.status))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 6,
                                  class: "text-button danger",
                                  onClick: ($event: any) => (_ctx.deleteExpense(item))
                                }, " Delete ", 8, _hoisted_75))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("tfoot", null, [
                      _createElementVNode("tr", null, [
                        _hoisted_76,
                        _createElementVNode("td", null, _toDisplayString(_ctx.pageTotal), 1),
                        _hoisted_77
                      ])
                    ])
                  ])
                ])),
          _createElementVNode("div", _hoisted_78, [
            _createElementVNode("button", {
              class: "secondary",
              disabled: _ctx.page <= 1,
              onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.changePage(_ctx.page - 1)))
            }, " Previous", 8, _hoisted_79),
            _createElementVNode("span", null, "Page " + _toDisplayString(_ctx.page) + " of " + _toDisplayString(_ctx.pageCount), 1),
            _createElementVNode("button", {
              class: "secondary",
              disabled: _ctx.page >= _ctx.pageCount,
              onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.changePage(_ctx.page + 1)))
            }, " Next ", 8, _hoisted_80)
          ])
        ]))
      : (_openBlock(), _createElementBlock("section", _hoisted_81, [
          _createElementVNode("div", _hoisted_82, [
            _hoisted_83,
            _createElementVNode("form", {
              class: "inline-form",
              onSubmit: _cache[37] || (_cache[37] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createCategory && _ctx.createCategory(...args)), ["prevent"]))
            }, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.newCategory) = $event)),
                placeholder: "New category name",
                required: ""
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.newCategory,
                  void 0,
                  { trim: true }
                ]
              ]),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.newCategoryParentId) = $event))
              }, [
                _hoisted_84,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rootCategories, (item) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: item.id,
                    value: Number(item.id)
                  }, " Subcategory of " + _toDisplayString(item.name), 9, _hoisted_85))
                }), 128))
              ], 512), [
                [
                  _vModelSelect,
                  _ctx.newCategoryParentId,
                  void 0,
                  { number: true }
                ]
              ]),
              _createElementVNode("button", {
                class: "primary",
                disabled: _ctx.savingMaster
              }, "Add", 8, _hoisted_86)
            ], 32),
            _createElementVNode("ul", _hoisted_87, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.id
                }, [
                  _createElementVNode("span", null, _toDisplayString(item.name), 1),
                  (Number(item.is_active))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "text-button danger",
                        onClick: ($event: any) => (_ctx.setCategoryActive(item, false))
                      }, " Deactivate", 8, _hoisted_88))
                    : (_openBlock(), _createElementBlock("span", _hoisted_89, "Inactive"))
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_90, [
            _hoisted_91,
            _createElementVNode("form", {
              class: "vendor-form",
              onSubmit: _cache[44] || (_cache[44] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createVendor && _ctx.createVendor(...args)), ["prevent"]))
            }, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.vendorForm.name) = $event)),
                placeholder: "Vendor name",
                required: ""
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.vendorForm.name,
                  void 0,
                  { trim: true }
                ]
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.vendorForm.contactPerson) = $event)),
                placeholder: "Contact person"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.vendorForm.contactPerson,
                  void 0,
                  { trim: true }
                ]
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.vendorForm.phone) = $event)),
                placeholder: "Phone"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.vendorForm.phone,
                  void 0,
                  { trim: true }
                ]
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.vendorForm.email) = $event)),
                type: "email",
                placeholder: "Email"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.vendorForm.email,
                  void 0,
                  { trim: true }
                ]
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.vendorForm.taxNo) = $event)),
                placeholder: "Tax number"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.vendorForm.taxNo,
                  void 0,
                  { trim: true }
                ]
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.vendorForm.address) = $event)),
                placeholder: "Address"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.vendorForm.address,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createElementVNode("button", {
                class: "primary",
                disabled: _ctx.savingMaster
              }, "Add vendor", 8, _hoisted_92)
            ], 32),
            _createElementVNode("ul", _hoisted_93, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vendors, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.id
                }, [
                  _createElementVNode("span", null, [
                    _createTextVNode(_toDisplayString(item.name), 1),
                    (item.contact_person)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_94, " · " + _toDisplayString(item.contact_person), 1))
                      : _createCommentVNode("", true)
                  ]),
                  (Number(item.is_active))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "text-button danger",
                        onClick: ($event: any) => (_ctx.setVendorActive(item, false))
                      }, " Deactivate", 8, _hoisted_95))
                    : (_openBlock(), _createElementBlock("span", _hoisted_96, "Inactive"))
                ]))
              }), 128))
            ])
          ])
        ])),
    (_ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("p", _hoisted_97, _toDisplayString(_ctx.errorMessage), 1))
      : _createCommentVNode("", true)
  ]))
}